module.exports = __webpack_public_path__ + "static/media/ic_searchtype_coast.c46fef18.svg";